export const cameraPosition = {
    HOME: [-5.49, 3.6, 7.03],
    HOME_SECTION_2: [-4.936874753598429, 11.294531383994077, 45.408613505608145],
    CUSTOMIZE: [0.24579448347847954, 3.898593615945031, 9.036006682875162],
    FEATURES: [0.24579448347847954, 3.898593615945031, 9.036006682875162],
};

export const controlsTarget = {
    HOME: [3.1271897394894195, 1.9258244781726472, 1.846361435585223],
    HOME_SECTION_2: [7.372610309467353, 9.792860939706488, 44.09502983217817],
    CUSTOMIZE: [0.20441110938811566, 2.3568463615030535, 0],
    FEATURES: [0.20441110938811566, 2.3568463615030535, 0],
};

export const mobileCameraPosition = {
    HOME: [-10.78156600831809, 5.096060034794816, 6.411009063160214],
    HOME_SECTION_2: [-35.62905876994354, 10.75858286269059, 58.073837357285825],
    CUSTOMIZE: [0.03035368216753841, 5, 15.972020789158245],
    FEATURES: [0.03035368216753841, 5, 15.972020789158245],
};

export const mobileControlsTarget = {
    HOME: [1.55801504442481, 2.6986863513646386, -1.011820410590962],
    HOME_SECTION_2: [0.881873846068983, 9.987540417958543, 56.43082285983605],
    CUSTOMIZE: [-0.02953866683046943, 3.8, 0],
    FEATURES: [-0.02953866683046943, 3.8, 0],
};